import React from 'react'
import { Columns, Element } from 'react-bulma-components'
import { Field, Form as FormikForm, Formik } from 'formik'
import { dateInputToDateValue } from '../../utils/date'
import { RequestButton, RequestMessage } from '../request-components/request-components'
import InputField from '../form/fields/input'
import CheckboxField from '../form/fields/checkbox'
import { useUpdateWorkerAutoClockingMutation } from '../../queries/users'

export interface AutoClockingFormValues {
  enabled: boolean
  from: string
  to: string
}

interface AutoClockingActionProps {
  enabledDefault: boolean
  fromDefault: string
  toDefault: string
  onSubmit: (values: AutoClockingFormValues) => Promise<void>
  mutation: ReturnType<typeof useUpdateWorkerAutoClockingMutation>
}

const AutoClockingAction: React.FC<AutoClockingActionProps> = ({
  enabledDefault,
  fromDefault,
  toDefault,
  onSubmit,
  mutation,
}) => {
  return (
    <>
      <Element renderAs="p" mb={3}>
        Activez l'auto-pointage pour cet interimaire sur une periode definie.
      </Element>
      <Formik<AutoClockingFormValues>
        enableReinitialize
        initialValues={{
          enabled: enabledDefault,
          from: fromDefault,
          to: toDefault,
        }}
        validate={values => {
          const errors: Partial<Record<keyof AutoClockingFormValues, string>> = {}
          if (values.enabled) {
            if (
              values.from &&
              values.to &&
              dateInputToDateValue(values.to) < dateInputToDateValue(values.from)
            )
              errors.to = 'La date de fin doit etre superieure ou egale a la date de debut'
          }
          return errors
        }}
        onSubmit={onSubmit}
      >
        {({ values }) => (
          <FormikForm>
            <Field component={CheckboxField} label="Autoriser l'auto-pointage" name="enabled" />
            {values.enabled && (
              <Columns mt={2}>
                <Columns.Column size={6}>
                  <Field label="Du" name="from" component={InputField} type="date" />
                </Columns.Column>
                <Columns.Column size={6}>
                  <Field label="Au" name="to" component={InputField} type="date" />
                </Columns.Column>
              </Columns>
            )}
            <Element mt={3}>
              <RequestButton
                color="primary"
                type="submit"
                mutation={mutation}
                data-test="save-auto-clocking"
              >
                Enregistrer
              </RequestButton>
            </Element>
          </FormikForm>
        )}
      </Formik>
      <RequestMessage mutation={mutation} />
    </>
  )
}

export default AutoClockingAction
